import { render } from "./StandardEnglishQA.vue?vue&type=template&id=0f90e390&scoped=true&ts=true"
import script from "./StandardEnglishQA.vue?vue&type=script&lang=ts"
export * from "./StandardEnglishQA.vue?vue&type=script&lang=ts"

import "./StandardEnglishQA.vue?vue&type=style&index=0&id=0f90e390&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f90e390"]])

export default __exports__